import { QuickReply } from "../types/message";
import { apiCore } from "./apiCore";

export const loadAllQuickReplies = async (
  idEnterprise: number,
): Promise<QuickReply[]> => {
  const response = await apiCore<QuickReply[]>(
    `/DootChat/${idEnterprise}/QuickReplies`,
    {
      method: "GET",
    },
  );

  return response.data;
};
